import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
} from '@angular/fire/firestore';
import { Session } from './session.model';
import { Product } from './product.model';
import { PaymentMethod } from '@stripe/stripe-js';

export enum EventPaymentEnum {
  CASH_ONLY = 'cash only',
  CASH_AND_CARD = 'cash and card',
  CARD_ONLY = 'card only',
}

export interface Event {
  id?: string;
  name: string;
  clientName: string;
  streetAddress: string;
  city: string;
  state: string;
  country: string;
  phoneNumber: string;
  description: string;
  startTime: Date;
  endTime: Date;
  pricing: number;
  products: Product[];
  organizerIds: string[];
  announcerIds: string[];
  sessions: Session[];
  paymentType: EventPaymentEnum;
  paymentIntentId: string | null;
  paymentMethod: string | PaymentMethod | null;
  eventCost: number;
  amountPaid: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export const eventConverter: FirestoreDataConverter<Event> = {
  toFirestore(event: Event): DocumentData {
    return {
      ...event,
      startTime: event.startTime.toISOString(),
      endTime: event.endTime.toISOString(),
      createdAt: event.createdAt?.toISOString(),
      updatedAt: event.updatedAt?.toISOString(),
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): Event {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      name: data['name'],
      clientName: data['clientName'],
      streetAddress: data['streetAddress'],
      city: data['city'],
      state: data['state'],
      country: data['country'],
      phoneNumber: data['phoneNumber'],
      description: data['description'],
      startTime: new Date(data['startTime']),
      endTime: new Date(data['endTime']),
      pricing: data['pricing'],
      products: data['products'] || [],
      organizerIds: data['organizerIds'],
      announcerIds: data['announcerIds'],
      sessions: data['sessions'],
      paymentType: data['paymentType'],
      paymentIntentId: data['paymentIntentId'],
      paymentMethod: data['paymentMethod'],
      eventCost: data['eventCost'],
      amountPaid: data['amountPaid'] || 0,
      createdAt: data['createdAt'] ? new Date(data['createdAt']) : undefined,
      updatedAt: data['updatedAt'] ? new Date(data['updatedAt']) : undefined,
    };
  },
};
